module.exports = __webpack_public_path__ + "img/icon-status-ok.a14eab44.svg";